import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/190/components/features/cases/OldComponents/cases/bonum/index.js");
